function isValidFeinNumber(fein) {
	if (fein && fein.length <= 10 && fein.match('(?!.*?^[0]{2})^[0-9][0-9]-?\\d{7}')) {
		return true;
	}
	return false;
}

export const validate = (values) => {
	const errors = {};
	if (!values.last_name) {
		errors.last_name = 'Required';
	}
	if (!values.first_name) {
		errors.first_name = 'Required';
	}

	if (!values.legal_business_name) {
		errors.legal_business_name = 'Required';
	}
	if (!values.email_address) {
		errors.email_address = 'Required';
	}

	if (!isValidFeinNumber(values.federal_employer_identification)) {
		if(values.federal_employer_identification && values.federal_employer_identification.length > 0){
			errors.federal_employer_identification = 'This is not a valid ein';
		}
		
	}

	return errors;
};
